import React, { Component } from "react";

class Inventory extends Component {
  render() {
    return <div className="inventory">Inventory!</div>;
  }
}

export default Inventory;



// WEBPACK FOOTER //
// ./src/components/Inventory.js